import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ScoringIngeService } from '../../service/scoring-inge.service';
import { ResultsInvoice } from '../../interface/company-client.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-dicom-formulario',
  templateUrl: './dicom-formulario.component.html',
  styleUrls: ['./dicom-formulario.component.scss'],
})
export class DicomFormularioComponent implements OnChanges {
  public deuda: number = 0;
  public puntaje: string = '';
  public fechaDeuda: string = '/';
  public historialDicom: number = 0;
  public booleanFlag: boolean = false;
  public pathUrlDicom: string = 'url';
  public update:boolean ;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: number,
    @Inject(MAT_DIALOG_DATA) public rut: string,
    private _changeRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<DicomFormularioComponent>,
    private equifaxService: ScoringIngeService
  ) {}

  ngOnInit() {
    //this.getDeudaDicomBD(this.data);
    this.getReportEquifaxBD(this.data);
    this.serializeBase64(this.data.toString());
  }

  ngOnChanges(changes: SimpleChanges) {
    //this._changeRef.detectChanges();
  }

  cerrarDialogo() {
    this.dialogRef.close();
  }

  serializeBase64(rut: string) {
    this.pathUrlDicom = this.getReportUrl(rut);
  }

  getReportUrl(rut: string) {
    var rutformat = rut.split('.').join('');

    var parametros =
      '{"Token":"IngeInternalApiKey55","Rut":"' + rutformat + '"}';
    var base64Datos = window.btoa(parametros);
    return (
      'https://scoringreport.inge.cl/api/Equifax/HtmlEncodedReport/' +
      base64Datos
    );
  }

  getReportEquifaxBD(rut: number) {
    var ruts = rut.toString();
    var rutformat = ruts.split('.').join('');
    var rutformat1 = rutformat.split('-').join('');
    var rutformat2 = rutformat1.substr(0, rutformat1.length - 1);
    this.equifaxService
      .getEquifaxReportBD(Number(rutformat2))
      .subscribe((result) => {
        if (result?.deudaDicom == null) {
          this.historialDicom = 1;
        } else {
          this.historialDicom = 2;
          this.deuda = result?.deudaDicom;
          this.fechaDeuda = result?.dateConsultaDicom;
          this.puntaje = result?.puntaje;
        }
      });
    (error) => {
      console.log('Error Get DicomPerona:' + error);
      Swal.fire({
        title: 'Error',
        text: 'consulta no realizada',
        heightAuto: false,
        icon: 'error',
      });
    };
  }

  getReportEquifaxScoring(rut: number) {
    Swal.fire({
      title: 'Consultando',
      text: 'Espere un momento',
      heightAuto: false,
      icon: 'info',
      didOpen: () => {
        Swal.showLoading();
        this.booleanFlag!;
        var ruts = rut.toString();
        var rutformat = ruts.split('.').join('');
        this.update = true;
        this.equifaxService.getEquifaxReportScoring(rutformat).subscribe(          
          (result) => {
            this.getReportEquifaxBD(rut);
            Swal.fire({
              heightAuto: false,
              title: 'Listo',
              text: 'Consulta realizada',
              icon: 'success',
            });
            this.dialogRef.close(this.update);
          },
          (error) => {
            console.log('Error Get DicomPerona:' + error);
            Swal.fire({
              heightAuto: false,
              title: 'Error',
              text: 'No se pudo realizar la consulta',
              icon: 'error',
            });
          }
        );
      },
    });
  }

  getDeudaDicomBD(rut: number) {
    var ruts = rut.toString();
    var rutformat = ruts.split('.').join('');
    var rutformat1 = rutformat.split('-').join('');
    var rutformat2 = rutformat1.substr(0, rutformat1.length - 1);
    this.equifaxService
      .getDeudaDicomBD(Number(rutformat2))
      .subscribe((result) => {
        if (result?.deudaDicom == null) {
          this.historialDicom = 1;
        } else {
          this.historialDicom = 2;
          this.deuda = result?.deudaDicom;
          this.fechaDeuda = result?.dateConsultaDicom;
          this.puntaje = result?.puntaje;
        }
      });
    (error) => {
      console.log('Error Get DicomPerona:' + error);
      Swal.fire({
        heightAuto: false,
        title: 'Error',
        text: 'consulta no realizada',
        icon: 'error',
      });
    };
  }

  getDeudaDicomEquifax(rut: number) {
    this.booleanFlag!;
    var ruts = rut.toString();
    var rutformat = ruts.split('.').join('');
    this.equifaxService.getDeudaDicom(rutformat).subscribe((result) => {
      this.getDeudaDicomBD(rut);
      console.log('Deuda-: ' + this.deuda);
      console.log('Fecha-: ' + this.fechaDeuda);
      Swal.fire({
        heightAuto: false,
        title: 'Consultado',
        text: 'Nueva consulta realizada',
        icon: 'success',
      });
    }),
      (error) => {
        console.log('Error Get DicomPerona:' + error);
        Swal.fire({
          heightAuto: false,
          title: 'Error',
          text: 'consulta no realizada',
          icon: 'error',
        });
      };
  }
}
